/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    0.75: '0.1875rem',
    1.125: '0.3125rem',
    2.75: '0.6875rem',
    4.5: '1.125rem',
    5.5: '1.375rem',
    6.5: '1.625rem',
    11: '2.75rem',
    11.25: '2.8125rem',
    13.5: '3.375rem',
    15: '3.75rem',
    18: '4.5rem',
    19: '4.75rem',
    // offset to use for link underline - as addition to default 1px
    linkUnderlineOffset: '0.3125rem'
}
